// @ts-nocheck

export class UnistylesMockedBridge {
  constructor() {}
  screenWidth() {}
  screenHeight() {}
  enabledPlugins() {}
  hasAdaptiveThemes() {}
  themeName() {}
  breakpoint() {}
  colorScheme() {}
  contentSizeCategory() {}
  sortedBreakpointPairs() {}
  insets() {}
  pixelRatio() {}
  fontScale() {}
  statusBar() {}
  navigationBar() {}
  themes(themes) {}
  useBreakpoints(breakpoints) {}
  useTheme(name) {}
  updateTheme(name) {}
  useAdaptiveThemes(enable) {}
  addPlugin(pluginName, notify) {}
  removePlugin(pluginName) {}
  setRootViewBackgroundColor(color, alpha) {}
  setImmersiveMode(isEnabled) {}
}
//# sourceMappingURL=UnistylesMockedBridge.js.map